<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates6">
<p class="centerImage"><img alt="images" id="plate6" src="images/plate6.jpg"/></p>
<p class="caption">My first CO, Squadron Leader Walter Churchill DSO DFC, 605 Squadron, July 1940.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates6.vue?308f7dde